<template>
  <transition-group
    name="staggered-fade"
    :tag="tag"
    v-bind:css="false"
    v-on:before-enter="beforeEnter"
    v-on:enter="enter"
    v-on:leave="leave"
  >
    <slot></slot>
  </transition-group>
</template>


<script>
export default {
  name: "list-transition",
  props: {
    tag: String,
    height: {
      type: String,
      default () {
        return "3.6em"
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.height = 0;
    },
    enter: function(el, done) {
      var delay = el.dataset.index * 150;
      let h = this.height
      setTimeout(function() {
        Velocity(el, { opacity: 1, height: h }, { complete: done });
      }, delay);
    },
    leave: function(el, done) {
      var delay = el.dataset.index * 150;
      setTimeout(function() {
        Velocity(el, { opacity: 0, height: 0 }, { complete: done });
      }, delay);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ListTransition.vue